import i18n from "@/i18n.ts";

export enum ApiWorkflowTriggerType {
  manual = "manual",
  scheduled = "scheduled",
  event = "event",
  recurring = "recurring",
}

export const getApiWorkflowTriggerTypeTitle = (type: ApiWorkflowTriggerType): string => {
  switch (type) {
    case ApiWorkflowTriggerType.manual:
      return i18n.t("workflow:workflow_trigger_type_manual");
    case ApiWorkflowTriggerType.scheduled:
      return i18n.t("workflow:workflow_trigger_type_scheduled");
    case ApiWorkflowTriggerType.event:
      return i18n.t("workflow:workflow_trigger_type_event");
    case ApiWorkflowTriggerType.recurring:
      return i18n.t("workflow:workflow_trigger_type_recurring");
  }
};

export const getApiWorkflowTriggerTypeLabel = (type: ApiWorkflowTriggerType): string => {
  switch (type) {
    case ApiWorkflowTriggerType.manual:
      return i18n.t("workflow:trigger_label_manual");
    case ApiWorkflowTriggerType.scheduled:
      return i18n.t("workflow:trigger_label_scheduled");
    case ApiWorkflowTriggerType.event:
      return i18n.t("workflow:trigger_label_event");
    case ApiWorkflowTriggerType.recurring:
      return i18n.t("workflow:trigger_label_recurring");
  }
};

export enum ApiWorkflowTriggerScheduleEntityType {
  time_off = "time_off",
  employee = "employee",
  custom_table_row = "custom_table_row",
}

export enum ApiWorkflowTriggerScheduleEntityField {
  // Применимо для time_offs
  date_start = "date_start",

  hire_date = "hire_date",
  terminate_date = "terminate_date",
  probation_ends_date = "probation_ends_date",
  birthday = "birthday",
  work_anniversary = "work_anniversary",

  custom_field = "custom_field",
  custom_table_column = "custom_table_column",
}

export const isCustomScheduleField = (
  field: ApiWorkflowTriggerScheduleEntityField | null | undefined
): boolean =>
  field === ApiWorkflowTriggerScheduleEntityField.custom_field ||
  field === ApiWorkflowTriggerScheduleEntityField.custom_table_column;

export enum ApiWorkflowTriggerScheduleDayType {
  calendar = "calendar",
  working = "working",
}

export enum ApiWorkflowBlockDelayReference {
  previous_block = "previous_block",
  trigger_date = "trigger_date",
}

export enum ApiWorkflowMeetingDateReference {
  block_execution = "block_execution",
  entity_date = "entity_date",
}

export enum ApiWorkflowTriggerScheduleTimezoneSource {
  employee = "employee",
  organization = "organization",
  custom = "custom",
}

export enum ApiWorkflowBlockTypes {
  start = "start",
  action = "action",
  end = "end",
}

export enum ApiWorkflowBlockActionTypes {
  none = "none",
  send_notification = "send_notification",
  http_request = "http_request",
  google_workspace = "google_workspace",
  invitation = "invitation",
  survey = "survey",
  task = "task",
  performance_review = "performance_review",
  performance_review_enroll = "performance_review_enroll",
  survey_enroll = "survey_enroll",
  run_workflow = "run_workflow",
  survey_with_approval = "survey_with_approval",
  esign = "esign",
  meeting = "meeting",
  candidate_email = "candidate_email",
  candidate_stage_change = "candidate_stage_change",
}

export enum ApiWorkflowEventTypes {
  employee_hired = "employee_hired",
  employee_created = "employee_created",
  employee_terminated = "employee_terminated",
  employee_termination_created = "employee_termination_created",
  employee_position_changed = "employee_position_changed",
  employee_position_change_created = "employee_position_change_created",
  employee_employment_changed = "employee_employment_changed",
  employee_employment_change_created = "employee_employment_change_created",
  employee_compensation_changed = "employee_compensation_changed",
  employee_compensation_change_created = "employee_compensation_change_created",
  time_off_request_approved = "time_off_request_approved",

  candidate_created = "candidate_created",
  candidate_stage_changed = "candidate_stage_changed",
  candidate_hired = "candidate_hired",
  candidate_disqualified = "candidate_disqualified",
  candidate_feedback_submitted = "candidate_feedback_submitted",
  offer_approved = "offer_approved",
  offer_rejected = "offer_rejected",
}

export const isCandidateWorkflowEventType = (
  eventType: ApiWorkflowEventTypes | null | undefined
): boolean => {
  switch (eventType) {
    case ApiWorkflowEventTypes.candidate_created:
    case ApiWorkflowEventTypes.candidate_stage_changed:
    case ApiWorkflowEventTypes.candidate_hired:
    case ApiWorkflowEventTypes.candidate_disqualified:
    case ApiWorkflowEventTypes.candidate_feedback_submitted:
    case ApiWorkflowEventTypes.offer_approved:
    case ApiWorkflowEventTypes.offer_rejected:
      return true;
    default:
      return false;
  }
};

export const getApiWorkflowEventTypesTitle = (type: ApiWorkflowEventTypes): string => {
  switch (type) {
    case ApiWorkflowEventTypes.employee_hired:
    case ApiWorkflowEventTypes.employee_created:
      return i18n.t("workflow:event_type_employee_hired");
    case ApiWorkflowEventTypes.employee_terminated:
    case ApiWorkflowEventTypes.employee_termination_created:
      return i18n.t("workflow:event_type_employee_terminated");
    case ApiWorkflowEventTypes.employee_position_changed:
    case ApiWorkflowEventTypes.employee_position_change_created:
      return i18n.t("workflow:event_type_employee_position_changed");
    case ApiWorkflowEventTypes.employee_employment_changed:
    case ApiWorkflowEventTypes.employee_employment_change_created:
      return i18n.t("workflow:event_type_employee_employment_changed");
    case ApiWorkflowEventTypes.employee_compensation_changed:
    case ApiWorkflowEventTypes.employee_compensation_change_created:
      return i18n.t("workflow:event_type_employee_compensation_changed");
    case ApiWorkflowEventTypes.time_off_request_approved:
      return i18n.t("workflow:event_type_time_off_request_approved");
    case ApiWorkflowEventTypes.candidate_created:
      return i18n.t("workflow:event_type_candidate_created");
    case ApiWorkflowEventTypes.candidate_stage_changed:
      return i18n.t("workflow:event_type_candidate_stage_changed");
    case ApiWorkflowEventTypes.candidate_hired:
      return i18n.t("workflow:event_type_candidate_hired");
    case ApiWorkflowEventTypes.candidate_disqualified:
      return i18n.t("workflow:event_type_candidate_disqualified");
    case ApiWorkflowEventTypes.candidate_feedback_submitted:
      return i18n.t("workflow:event_type_candidate_feedback_submitted");
    case ApiWorkflowEventTypes.offer_approved:
      return i18n.t("workflow:event_type_offer_approved");
    case ApiWorkflowEventTypes.offer_rejected:
      return i18n.t("workflow:event_type_offer_rejected");
  }
};
